module.exports = "//static.hsappstatic.net/codemirror/static-5.62/codemirror.css"